import React, { HTMLProps } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const StyledInputContainer = styled.div`
  border: 1px solid #34353b;
  border-radius: 3px;
  padding: 6px 10px;
  background-color: #25262d;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  > p {
    margin: 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
  }
  > input {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: #fff;
    width: 100%;
    &:focus {
      outline: none;
    }
  }
`;

interface InputProps extends HTMLProps<HTMLInputElement> {
  name?: string;
  wrapperStyle?: React.CSSProperties;
}

export const Input = ({ name, wrapperStyle, ...rest }: InputProps) => {
  return (
    <InputWrapper style={wrapperStyle}>
      <StyledInputContainer>
        {name ? <p>{name}</p> : null}
        <input {...rest} />
      </StyledInputContainer>
    </InputWrapper>
  );
};
